import React, { useEffect, useMemo, useState } from "react";
import TimeDisplay from "./TimeDisplay";
import TimezoneSelector from "./TimezoneSelector";
import useTimePreferences from "../../hooks/useTimePreferences";
import {
  getEffectiveTimezone,
  saveTimePreferences,
} from "../../utils/timePreferences";
import "./time.css";

const HeaderTimeWidget = ({ variant = "toolbar", showSelector = true }) => {
  const preferences = useTimePreferences();
  const [now, setNow] = useState(() => new Date());
  const localTimezone = getEffectiveTimezone(preferences);

  useEffect(() => {
    let intervalId;
    const tick = () => {
      setNow(new Date());
      intervalId = window.setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    tick();
    return () => window.clearTimeout(intervalId);
  }, []);

  const clocks = useMemo(
    () => [
      {
        id: "utc",
        clockId: "utc",
        label: "UTC",
        timezone: "UTC",
        timeFormat: "24",
        primary: true,
      },
      ...(preferences.showLocalTime
        ? [
            {
              id: "local",
              clockId: "local",
              label: "Local",
              timezone: localTimezone,
              timeFormat: preferences.timeFormat,
            },
          ]
        : []),
    ],
    [localTimezone, preferences.showLocalTime, preferences.timeFormat],
  );

  return (
    <section
      className={`header-time-widget header-time-widget--${variant}`}
      aria-label="Operational time reference"
    >
      <div className="header-time-widget__clocks">
        {clocks.map((clock) => (
          <TimeDisplay
            key={clock.id}
            {...clock}
            date={now}
            dateFormat={preferences.dateFormat}
          />
        ))}
      </div>
      {preferences.showLocalTime && showSelector && (
        <TimezoneSelector
          value={preferences.selectedTimezone}
          manualOffset={
            preferences.timeSource === "manual" ? preferences.manualOffset : null
          }
          onSave={(selectedTimezone) =>
            saveTimePreferences({
              ...preferences,
              timeSource: "timezone",
              selectedTimezone,
              autoDetectTimezone: false,
              manualOffset: null,
            })
          }
        />
      )}
    </section>
  );
};

export default HeaderTimeWidget;
